import { Outlet } from 'react-router'

const AccountsMainLayout = () => {
  return (
    <Outlet />
  )
}

export default AccountsMainLayout